export const TableSortHeaders = (headerConfig, sort, order, setSort, setOrder, setPage) => {
    const handleHeaderClick = (field) => {
        console.log(field)
        if (!field) return;
        if (sort === field) {
            setOrder(prev => (prev === "asc" ? "desc" : "asc"));
        } else {
            setSort(field);
            setOrder("asc");
        }
        setPage(1);
    };

    return headerConfig.map((col) => {
        if (col.sortable) {
            return (
                <th
                    key={col.key}
                    className="text-sm cursor-pointer"
                    onClick={() => handleHeaderClick(col.key)}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <span>{col.label}</span>
                        <span style={{ width: "12px", display: "inline-block" }}>
                            {sort === col.key ? (order === "asc" ? "↑" : "↓") : ""}
                        </span>
                    </div>
                </th>
            );
        } else {
            return (
                <th key={col.key} className="text-sm">
                    {col.label}
                </th>
            );
        }
    });
};
